import { SR_API_ACTION_UPDATE_TOUR_SHOWING_STATUS } from 'api/actionTypes';

export default async function updateShowingStatus({ state, apiClient }, params) {
  const { listingId, tourId, showingStatus, failureReason, failureReasonAgentProvided } = params;

  return apiClient.postWithState({
    action: SR_API_ACTION_UPDATE_TOUR_SHOWING_STATUS,
    state: state,
    payload: {
      listingId,
      tourId,
      showingStatus,
      failureReason,
      failureReasonAgentProvided,
    },
  });
}
